// extracted by mini-css-extract-plugin
export var container = "styles-module__container___JS6uP";
export var innerContainer = "styles-module__innerContainer___yKUfm";
export var textContainer = "styles-module__textContainer___wMULK";
export var header = "styles-module__header___R4seQ";
export var greatBenefits = "styles-module__greatBenefits___H38Oe";
export var benefitsText = "styles-module__benefitsText___dZE2C";
export var benefitsContainer = "styles-module__benefitsContainer___dxTMc";
export var river = "styles-module__river___xm_sH";
export var benefitCard = "styles-module__benefitCard___y4wNd";
export var benefitIcon = "styles-module__benefitIcon___FjInf";
export var benefitTitle = "styles-module__benefitTitle___rQDx2";
export var benefitDesc = "styles-module__benefitDesc___iicw5";